/**
 * axios封装
 * 请求拦截、响应拦截、错误统一处理
 */
import axios from 'axios'
import QS from 'qs'

console.log(process.env.QUICK_CREATE_ENV)

axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8'
axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? location.origin : 'http://localhost:3000' // 发送请求的基础url
axios.defaults.timeout = 10000 // 请求的超时时间
axios.defaults.paramsSerializer = params => {
  return QS.stringify(params, { arrayFormat: 'repeat' })
}
// axios.defaults.withCredentials = true // 需要跨域携带认证

// 请求拦截器
axios.interceptors.request.use(config => {
  // eslint-disable-next-line
  if (config.dataType === 'file') { // 文件上传兼容
    config.headers.common['Content-Type'] = 'multipart/form-data'
  }
  return config
})

// 响应拦截器
axios.interceptors.response.use(res => {
  console.log(res)
  return res.data
}, (err) => {
  console.log(err)
  return Promise.reject(err.message)
})

/**
 *  函数的参数options为axios的配置
 *  method => 方法名 "POST"等
 *  url => 路径,实际调用时传type即可，即为urlDict的key
 *  data => 数据的对象
 *  调用前将type值转为对应的url
 */
const request = (options) => {
  // options.headers = options.headers || {}
  options.method = options.method || 'get'
  if (options.method.toUpperCase() === 'GET') {
    options.params = options.data
    delete options.data
  }
  return axios(options)
}

export default request
